export const timeout = (ms: any) =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });

export const safe = async (promise: any, errorCallback: any) => {
    let res;
    try {
        res = await promise;
    } catch (e) {
        if (errorCallback) errorCallback(e);
        res = undefined;
    }
    return res;
};
